import { render } from "./Pagination.vue?vue&type=template&id=5283780e&scoped=true"
import script from "./Pagination.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Pagination.vue?vue&type=script&charset=utf-8&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=5283780e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5283780e"]])

export default __exports__